/* unplugin-vue-components disabled */import script from "./HotelStockPrice.vue?vue&type=script&setup=true&lang=jsx"
export * from "./HotelStockPrice.vue?vue&type=script&setup=true&lang=jsx"

import "./HotelStockPrice.vue?vue&type=style&index=0&id=0a786472&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a786472"]])

export default __exports__